/**
 * Fonts drawer — mount point for the Design tab's Fonts section.
 * See colors-drawer.js for the Phase B.1 adapter rationale.
 */

import { eventBus } from '../../core/events.js';

/**
 * @param {HTMLElement} bodyEl
 * @param {{ panel: import('../property-panel.js').PropertyPanel }} ctx
 */
export function renderFontsContent(bodyEl, { panel }) {
  if (!bodyEl || !panel) return () => {};

  // _renderFontsSubpanel() calls _wireFontsSubpanel() internally — don't
  // double-wire. State-changed updates route through the in-place
  // _refreshTypographySection so element references stay live.
  panel._renderFontsSubpanel(bodyEl);

  const off = eventBus.on('state-changed', () => panel._refreshTypographySection(bodyEl));
  return () => {
    off?.();
  };
}
